export const isDictEmpty = (dict: Object) => {
  return JSON.stringify(dict) === JSON.stringify({})
}